import { render } from "./ReservCard.vue?vue&type=template&id=8593df48&scoped=true"
import script from "./ReservCard.vue?vue&type=script&lang=js"
export * from "./ReservCard.vue?vue&type=script&lang=js"

import "./ReservCard.vue?vue&type=style&index=0&id=8593df48&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8593df48"]])

export default __exports__